import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Grid,
  Typography,
} from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

const DashBoard = ({ filter }) => {
  return (
    <Box
      sx={{
        background: "#181818",
        color: "white",
        minHeight: "100vh",
        pl: 10,
        pr: 10,
        pt: 2,
        pb: 10,
      }}
    >
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 2, sm: 8, md: 12 }}
      >
        {filter.map((item, index) => (
          <Grid item xs={2} sm={4} md={3} key={index}>
            <Link className="link" to={`/videos/${item._id}`}>
              <Card sx={{ maxWidth: 345 }}>
                <CardActionArea>
                  <CardMedia
                    component="img"
                    height="140"
                    image={item.previewImage}
                    alt="green iguana"
                  />
                  <CardContent sx={{ bgcolor: "#181818", textAlign: "left" }}>
                    <Typography
                      gutterBottom
                      variant="h5"
                      component="div"
                      sx={{ fontSize: 14, color: "white" }}
                    >
                      {item.title}
                    </Typography>
                    <Typography variant="body2" color="#D1D5DA">
                      {item.releaseDate}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Link>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default DashBoard;
